import { VisualDataQuery, VisualDataSource } from '../VisualDataSource';
import { VisualDataRequest } from '../VisualDataRequest';

export class ArrayVisualDataSource extends VisualDataSource {
  constructor(public readonly rows: ReadonlyArray<ReadonlyArray<any>>) {
    super();
  }

  protected queryImpl(request: VisualDataRequest): VisualDataQuery {
    throw new Error(`Not implemented`);
  }
}
